import { useDropzone } from "react-dropzone";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import cx from "classnames";
import { useTranslate } from "../../hooks/useTranslate";
import IconFile from "../../assets/images/icons/file.svg?react";
import { formatBytes } from "../../utils/formatBytes";
import "./FileDropUploader.css";

const FileDropUploader = (props) => {
    const {
        accept, showFiles, maxFiles, multiple, disabled,
        uploadedFiles,
        uploadTextElement,
        className,
        error,
        onChange,
    } = props;

    const { t } = useTranslate();

    const {
        getRootProps, getInputProps, open, acceptedFiles, inputRef,
    } = useDropzone({
        noClick: true,
        noKeyboard: true,
        accept,
        disabled,
        maxFiles,
        multiple,
        onDrop: onChange,
    });

    return (
        <div className={cx("file-drop-uploader", { "file-drop-uploader--disabled": disabled }, { "file-drop-uploader--error": error }, className)}>
            <div {...getRootProps({ className: "file-drop-uploader__dropzone" })}>
                <input {...getInputProps()} />
                <div className="file-drop-uploader__icon">
                    <IconFile />
                </div>
                <div className="file-drop-uploader__text">
                    {uploadTextElement || t("uploader.dragPrUpload")}
                </div>
                <Button variant="contained" className="button-accent file-drop-uploader__button" onClick={open}>
                    {acceptedFiles.length > 0 ? t("uploader.reupload") : t("uploader.upload")}
                </Button>
            </div>
            {(showFiles && acceptedFiles.length > 0) && (
                <aside className="file-drop-uploader__files">
                    <Typography variant="h4" className="file-drop-uploader__file-title">
                        {t("uploader.files")}
                    </Typography>
                    <ul className="file-drop-uploader__file-list">
                        {acceptedFiles.map((file) => (
                            <li key={file.name} className="file-drop-uploader__file-item">
                                {`${file.name} - `}
                                <i>{formatBytes(file.size)}</i>
                            </li>
                        ))}
                    </ul>
                </aside>
            )}
            {(acceptedFiles?.length === 0 && uploadedFiles?.length > 0) && (
                <aside className="file-drop-uploader__files">
                    <Typography variant="h4" className="file-drop-uploader__file-title">
                        {t("uploader.filesUploaded")}
                    </Typography>
                    <ul className="file-drop-uploader__file-list">
                        {uploadedFiles.map((file) => (
                            <li key={file.documentId} className="file-drop-uploader__file-item">
                                {file.fileName}
                            </li>
                        ))}
                    </ul>
                </aside>
            )}
        </div>
    );
};

export default FileDropUploader;
